import Vue from 'vue';

import 'highlight.js/styles/stackoverflow-light.css';

import vuePlugin from "./highlight-vue.js";
Vue.use(vuePlugin);
